import { lazyLoad } from 'controller/utils/loadable';

export const AgenticTasks = lazyLoad(
  () => import('./index'),
  module => module.AgenticTasks,
);
